import { requestWrapper } from './reusable';

const config = require('../../config')();

// Both endpoints hit the ROS backend `retailauth` lambda, which authorizes the caller's
// Okta bearer token against the App.Retail-DevOps.* AD groups, mints an Oscar S2S
// token, and proxies to Workforce Profile v3. The caller's email is derived server-side
// from the Okta token, so the frontend intentionally sends no identifier on GET.
export const getRetailAuthProfile = (token) => requestWrapper(
  token,
  config.rapRetailAuthProfileResource,
  'get',
);

export const submitDevOpsUserSetup = (token, body) => requestWrapper(
  token,
  config.rapRetailAuthProvisionResource,
  'post',
  undefined,
  body,
);
